import { fetchTableElementData } from "../../helpers/data-catalogue-api"
import { UpdateDataDictionaryTable } from "./data-dictionary-table"
import {
    renderPreviousButton,
    renderNextButton,
    renderPaginationOptions,
} from "../catalogue-search/render-pagination"
import { getTranslations } from "../catalogue-search/get-translations"
import { UpdateDataDictionaryMobileCard } from "./data-dictionary-mobile-card"

export function setPaginationEvents(paginationElements) {
    if (paginationElements.length > 0) {
        ;[...paginationElements].forEach(async (pagination) => {
            await setNavigationEvents(pagination)
        })
    }
}

export async function setNavigationEvents(navigationElement) {
    if (navigationElement) {
        navigationElement.addEventListener("click", async (e) => {
            e.preventDefault()

            const pageTarget = navigationElement.dataset.pageTarget
            const selector = document.getElementById("dataDictionarySelector")

            const params = new URLSearchParams(window.location.search)

            const originId = params.get("originId")
            const catalogueId = params.get("id")

            if (!catalogueId || !originId) {
                console.error("Missing catalogue ID or origin ID in URL parameters")
                return
            }

            try {
                const data = await fetchTableElementData(
                    catalogueId,
                    selector.value,
                    originId,
                    pageTarget
                )

                UpdateDataDictionaryTable(data.result)
                UpdateDataDictionaryMobileCard(data.result)
                updatePagination(data)

                requestAnimationFrame(() => {
                    const wrapper = document.getElementById("data-dictionary")
                    if (wrapper) {
                        const yOffset = -95
                        const y = wrapper.getBoundingClientRect().top + window.pageYOffset + yOffset
                        window.scrollTo({ top: y, behavior: "smooth" })
                    }
                })
            } catch (error) {
                console.error("Error during pagination:", error)
                return
            }
        })
    }
}

export async function updatePagination(paginationInfo) {
    const paginationContainer = document.getElementById("paginationContainer")
    const translations = await getTranslations

    paginationContainer.innerHTML = ""

    if (paginationInfo.totalPages > 1) {
        paginationContainer.innerHTML = `
        <div class="mt-5 flex w-full justify-center">
            <div class="inline-flex items-center gap-6 rounded-full border border-green-200 px-6 py-3 text-base font-bold">
                ${renderPreviousButton(paginationInfo, translations)}
                <ul class="pagination">
                    ${renderPaginationOptions(paginationInfo)}
                </ul>
                ${renderNextButton(paginationInfo, translations)}
            </div>
        </div>
        `

        const previousPageElement = document.querySelector(".pagination-js-search-previous")
        const nextPageElement = document.querySelector(".pagination-js-search-next")

        setNavigationEvents(previousPageElement)
        setNavigationEvents(nextPageElement)

        const paginationElements = document.getElementsByClassName("pagination-js-search")
        setPaginationEvents(paginationElements)
    }
}
